export enum Colors {
  BLUE = '#2BA3EF',
  DARK_BLUE = '#134471',
  WHITE = '#ffffff',
  GRAY = '#212529',
  RED = '#FF0000',
  GREEN = '#00a463'
}

export enum SleepStageColors {
  deep = '#0C1A2E',
  light = '#1BA7FF',
  rem = '#43DCA5',
  awake = '#C51D45'
}

export enum RefRangesColors {
  criticalLowKey = '#ff0000',
  criticalHighKey = '#ff0000',
  significantlyLowKey = '#EC3F60',
  normalKey = '#00a463',
  normalHighKey = '#20c997',
  highKey = '#ffcc00',
  lowKey = '#ffcc00',
  significantlyHighKey = '#fe8900'
}

export enum AlertColors {
  _50 = '#EB5757',
  _30 = '#F2994A',
  _20 = '#F2C94C',
  _15 = '#00D291',
  _10 = '#2F80ED'
}

export enum Scatter {
  red = '#FF0000',
  green = '#00A463',
  yellow = '#FFCC00',
  orange = '#fe8900',
  green2 = '#20c997'
}

export enum TagColors {
  _10 = '#45AFF2',
  _20 = '#0439bf',
  _30 = '#38F3CC',
  _40 = '#E22E73',
  _50 = '#7F0AF0',
  _60 = '#F9D668',
  _70 = '#EB6012',
  _80 = '#EB6383',
  _90 = '#AAEE99',
  _100 = '#FBC687',
  _110 = '#5F6CAF',
  _120 = '#ECCE6D',
  _130 = '#706F65',
  _140 = '#721B65',
  _150 = '#00BDAA',
  _160 = '#C38DEA',
  _170 = '#222B64',
  _180 = '#045587',
  _190 = '#36CC32',
  _200 = '#D3238D'
}

export enum ReportsColors {
  PALE_BLUE = '#CAE8FB',
  LIGHT_BLUE = '#2BA3EF',
  BLUE = '#296FA2',
  DARK_BLUE = '#144471',
  LIGHT_GRAY = '#D1D6DA',
  GRAY = '#A6A6A6',
  DARK_GRAY = '#293943',
  GOLD = '#D4AF37',
  GREEN = '#00FF00',
  BLACK = '#000000'
}
